import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './component/layout/MainLayout.jsx';
import HomePage from './component/pages/Home.jsx';
import ScrollToTop from './component/common/ScrollToTop.jsx';
import Services from './component/pages/Services.jsx';
import About from './component/pages/About.jsx';
import Contact from './component/pages/ContactUs.jsx';

function App() {
  return (
    <>
     <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
      </Routes>
    </Router>
    </>
  );
}

export default App;
